<template>
  <div class="pkg-content" v-loading="dataListLoading">
    <el-row>
      <el-col :span="24" align="right">
        <el-button type="primary" @click="handleSave" v-if="type !== 'view'"
          >{{ $t("save") }}
        </el-button>
        <el-button type="primary" @click="handleBack"
          >{{ $t("user.back") }}
        </el-button>
      </el-col>
    </el-row>
    <div class="divider" />

    <el-form
      class="pkg-content"
      label-width="auto"
      label-position="top"
      :model="dataForm"
      ref="dataForm"
      :rules="rules"
    >
      <el-row class="margb10" :gutter="30">
        <el-col :span="6">
          <el-form-item label="组织类别名称" prop="orgCategoryName">
            <el-input
              maxlength="50"
              :disabled="type === 'view'"
              v-model="dataForm.orgCategoryName"
              :placeholder="$t('请输入')+'最大50字符'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6" v-if="type !== 'new'">
          <el-form-item label="版本号">
            <el-input
              disabled
              v-model="dataForm.versionNo"
              :placeholder="$t('请输入')"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" style="margin-top: 20px;">
          <el-form-item label="组织类别描述">
            <el-input
              style="width:100%"
              :disabled="type === 'view'"
              type="textarea"
              v-model="dataForm.orgCategoryDesc"
              :placeholder="type === 'view' ? '': $t('请输入')+'最大1000字符'"
              maxlength="1000"
              show-word-limit
              :rows="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div style="margin-top: 20px;">
        <!-- 新增 btnAdded -->
        <el-button v-if="type !== 'view'" type="primary" @click="handleDownload"
          >模板下载
        </el-button>

        <el-button v-if="type !== 'view'" type="primary" @click="handleImport"
          >导入
          <el-tooltip
            class="item"
            effect="dark"
            content="导入只支持Excel格式文件，最大10M"
            placement="top"
          >
            <em style="color:#fff;" class="el-icon-question"></em>
          </el-tooltip>
        <!--  导入
          <el-tooltip
                  class="item"
                  effect="dark"
                  content="导入只支持Excel格式文件，最大10M"
                  placement="top"
          >
            <img
                    style="width: 14px; height: 14px"
                    src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                    alt=""
            />-->
          </el-tooltip>
        </el-button>

        <el-button v-if="type === 'view'" type="primary" @click="handleDownload"
          >导出
        </el-button>
      </div>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tablePagingData"
      border
      :row-style="{ height: 48 + 'px' }"
      :cell-style="{ padding: 0 + 'px' }"
    >
      <el-table-column
        prop="orgCode"
        label="组织编号"
        header-align="center"
        align="center"
        min-width="80"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!--CBU-->
      <el-table-column
        prop="nscNo"
        label="NSC No.(CBU)"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        min-width="120"
      ></el-table-column>

      <!--CKD-->
      <el-table-column
        label="BBA No.(CKD)"
        prop="bbaNo"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
        min-width="120"
      ></el-table-column>
      <!-- 公司名称 -->
      <el-table-column
        prop="abbreviationCn"
        label="公司名称"
        header-align="center"
        min-width="120"
        align="left"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <!-- 经销商品牌 -->
      <el-table-column
        prop="brand"
        label="经销商品牌"
        :formatter="brandFormatter"
        header-align="center"
        align="center"
        min-width="120"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- 网点类型 -->
      <el-table-column
        prop="networkType"
        :formatter="networkType"
        label="网点类型"
        header-align="center"
        min-width="120"
        :show-overflow-tooltip="true"
        align="center"
      ></el-table-column>
      <!-- 培训免费开始时间 -->
      <el-table-column
        prop="freeDateS"
        label="培训免费开始时间"
        header-align="center"
        min-width="120"
        :show-overflow-tooltip="true"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeDateS.split(" ")[0] }}
          </div>
        </template>
      </el-table-column>
      <!-- 培训免费有效期至 -->
      <el-table-column
        prop="freeDateE"
        label="培训免费有效期至"
        header-align="center"
        align="center"
        min-width="120"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.freeDateE.split(" ")[0] }}
          </div>
        </template></el-table-column
      >
    </el-table>
    <el-pagination
      :current-page="tablePaging.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="tablePaging.pageSize"
      :total="dataForm.orgCategoryDetailDTOList.length"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>

    <import-excel
      v-bind:visible="dialogVisible"
      v-bind:url="uploadUrl"
      v-on:closeDialogImport="dialogVisible = false"
      @getData="getData"
    ></import-excel>
  </div>
</template>

<script>
// import mixinViewModule from "@/mixins/view-module";
import Vue from "vue";
import importExcel from "./components/import";
export default {
  name: "",
  components: {
    importExcel,
  },
  // mixins: [mixinViewModule],
  data() {
    let _this = this;
    return {
      // mixinViewModuleOptions: {
      //   activatedIsNeed: false,
      // },
      rules: {
        orgCategoryName: [
          { required: true, message: "请输入组织类别名称", trigger: "blur" },
        ],
      },
      dataListLoading: false,
      tablePaging: {
        pageNum: 1,
        pageSize: 10,
        data: [],
      },

      dataForm: {
        id: "",
        orgCategoryNo: "",
        orgCategoryName: "",
        orgCategoryDesc: "",
        versionNo: "",
        categoryCreateUser: "",
        categoryUpdateUser: "",
        // createTime:"",
        // createUser:"",
        // updateTime:"",
        // updateUser:"",
        // deleteFlag:"",
        orgCategoryDetailDTOList: [],
      },
      state: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "0",
          label: "停用",
        },
      ],
      dialogVisible: false,
      uploadUrl: "/learning/rule/orgcategorydetail/importExcel",
      type: "",
      dataRule: {
        // siteNo: [
        //   { required: true, message: this.$t('res.site.code') + this.$t('res.site.notNull'), trigger: 'blur' }
        // ],
        orgCategoryName: [
          {
            required: true,
            message:
              this.$t("res.site.ChineseName") + this.$t("res.site.notNull"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  // 计算属性
  //computed: {},
  watch: {},
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.type = this.$route.params.type;
    this.initMethod();
    this.dataForm = JSON.parse(JSON.stringify(this.dataForm));
    if (this.type === "view") {
      this.$eventHub.$on("organizationCategoryView", (data) => {
        this.initMethod();
        this.$refs.dataForm.clearValidate();
      });
    } else if (this.type === "edit") {
      this.$eventHub.$on("organizationCategoryEdit", (data) => {
        this.initMethod();
        this.$refs.dataForm.clearValidate();
      });
    } else if (this.type === "new") {
      this.$eventHub.$on("organizationCategoryNew", (data) => {
        this.initMethod();
        this.$refs.dataForm.clearValidate();
      });
    }
  },
  destroyed() {
    this.$eventHub.$off("organizationCategoryView");
    this.$eventHub.$off("organizationCategoryEdit");
    this.$eventHub.$off("organizationCategoryNew");
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    console.log('mounted')
  },
  activated() {
    // this.initMethod();
  },
  methods: {
    initMethod() {
      if (this.type !== "new") {
        if (this.$route.params) {
          this.dataForm.id = this.$route.params.id;
          this.getInfo();
        }
      }
    },
    getData(data) {
      this.dataForm.orgCategoryDetailDTOList = data;
    },
    // 获取信息s
    getInfo() {
      this.dataListLoading = true;
      if (this.$route.params.isNow) {
        this.$request
          .get(`/learning/rule/orgcategory/${this.dataForm.id}`)
          .then((data) => {
            this.dataForm.orgCategoryNo = data.orgCategoryNo;
            this.dataForm.orgCategoryName = data.orgCategoryName;
            this.dataForm.orgCategoryDesc = data.orgCategoryDesc;
            this.dataForm.versionNo = data.versionNo;
            this.dataForm.categoryCreateUser = data.categoryCreateUser;
            this.dataForm.categoryUpdateUser = data.categoryUpdateUser;
            this.dataForm.orgCategoryDetailDTOList =
              data.orgCategoryDetailDTOList;
            this.dataListLoading = false;
          })
          .catch(() => {
            this.dataListLoading = false;
          });
      } else {
        this.$request
          .get(`/learning/rule/orgcategoryhis/${this.dataForm.id}`)
          .then((data) => {
            console.log(data);
            this.dataForm.orgCategoryNo = data.orgCategoryNo;
            this.dataForm.orgCategoryName = data.orgCategoryName;
            this.dataForm.orgCategoryDesc = data.orgCategoryDesc;
            this.dataForm.versionNo = data.versionNo;
            this.dataForm.categoryCreateUser = data.categoryCreateUser;
            this.dataForm.categoryUpdateUser = data.categoryUpdateUser;
            this.dataForm.orgCategoryDetailDTOList =
              data.orgCategoryDetailHisDTOList;
            this.dataListLoading = false;
          })
          .catch(() => {
            this.dataListLoading = false;
          });
      }
    },
    handleSave() {
      this.$refs["dataForm"].validate((valid) => {
        if (this.tablePagingData.length === 0) {
          return this.$message({
            message: "请导入组织类别明细",
            type: "error",
            duration: 2000,
          });
        }
        if (valid) {
          this.$confirm('是否保存为新版本?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.dataListLoading = true;
              let url = "/learning/rule/orgcategory";
              let param = "";
              param = {
                id: this.dataForm.id || undefined,
                orgCategoryNo: this.dataForm.orgCategoryNo,
                orgCategoryName: this.dataForm.orgCategoryName,
                orgCategoryDesc: this.dataForm.orgCategoryDesc,
                versionNo: this.dataForm.versionNo,
                categoryCreateUser: this.dataForm.categoryCreateUser,
                categoryUpdateUser: this.dataForm.categoryUpdateUser,
                orgCategoryDetailDTOList: this.dataForm.orgCategoryDetailDTOList,
              };
              if (this.type == "edit") {
                this.$request
                  .put(url, this.dataForm)
                  .then((data) => {
                    this.$message({
                      message: this.$t("prompt.success"),
                      type: "success",
                      duration: 500,
                      onClose: () => {
                        // this.saveType = 'saveSeccess'
                        // this.$refs.cityClassRef.resetChecked()
                        // this.$refs.classRef.resetChecked()
                        // this.addType = false
                        // this.$router.go(-1)
                        this.dataListLoading = false;
                        this.tabRemove(this.$store.state.contentTabsActiveName);
                      },
                    });
                  })
                  .catch(() => {
                    this.dataListLoading = false;
                  });
              }else if (this.type == "new") {
                this.$request
                  .post(url, this.dataForm)
                  .then((data) => {
                    this.dataListLoading = false;
                    this.$message({
                      message: this.$t("prompt.success"),
                      type: "success",
                      duration: 500,
                      onClose: () => {
                        // this.saveType = 'saveSeccess'
                        // this.$refs.cityClassRef.resetChecked()
                        // this.$refs.classRef.resetChecked()
                        // this.addType = false
                        // this.$router.go(-1)
                        this.tabRemove(this.$store.state.contentTabsActiveName);
                      },
                    });
                  })
                  .catch(() => {
                    this.dataListLoading = false;
                  });
              }
            }).catch((err) => {
              console.log(err)
            })
        }
      });
    },
    handleBack() {
      // this.tabRemove(this.$store.state.contentTabsActiveName);
      this.$router.push({
        path: "/manage/charge-organizationCategory-index",
        params: {},
      });
    },

    tabRemove(tabName) {
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        (item) => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          path: "/manage/charge-organizationCategory-index",
        });
      }
    },
    handleDownload() {
      this.dataListLoading = true;
      // download 参数 url, params, 报表名
      if (this.$route.params.isNow) {
        this.$request
          .loadingDownload(
            `/learning/rule/orgcategorydetail/export?id=${
              this.type === "new" ? -1 : this.dataForm.id
            }`,
            this.type === "view" ?  "组织类别":"组织类别导入模板"
          )
          .then((data) => {
            this.dataListLoading = data;
          });
      } else {
        this.$request
          .loadingDownload(
            `/learning/rule/orgcategorydetailhis/export?id=${
              this.type === "new" ? -1 : this.$route.params.downloadId
            }&versionNo=${this.dataForm.versionNo}`,
            this.type === "view" ?  "组织类别":"组织类别导入模板"
          )
          .then((data) => {
            this.dataListLoading = data;
          });
      }
    },
    handleImport() {
      this.dialogVisible = true;
    },
    handleDialogImport() {
      console.log('handleDialogImport')
    },
    // 上传成功
    handleSuccess(response, file, fileList) {
      this.fileList = [];
    },
    beforeExcelUpload(file, fileList) {
      let maxLength = 20 * 1024 * 1024;
      if (file.size > maxLength) {
        this.$message({
          message: "文件大小不能超过20M",
          type: "error",
          duration: 1500,
          onClose: () => {
            console.log('onClose')
          },
        });
        return false;
      }
      return true;
    },
    // 分页, 每页条数
    pageSizeChangeHandle(val) {
      this.tablePaging.pageNum = 1;
      this.tablePaging.pageSize = val;
    },
    // 分页, 当前页
    pageCurrentChangeHandle(val) {
      this.tablePaging.pageNum = val;
    },

    brandFormatter(row) {
      return Vue.filter("coverEnumList")(row.brand, "brandCode", ",");
    },
    networkType(row) {
      return Vue.filter("coverEnum")(row.networkType, "networkType");
    },
  },
  computed: {
    // 表格分页
    tablePagingData() {
      let start = (this.tablePaging.pageNum - 1) * this.tablePaging.pageSize;
      let end = this.tablePaging.pageNum * this.tablePaging.pageSize;
      return this.dataForm.orgCategoryDetailDTOList.slice(start, end);
    },
  },
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
@import "../../../css/pkg-styles.css";
.divider {
  display: block;
  height: 2px;
  width: 100%;
  margin: 24px 0;
  background-color: #a2a2a2;
  position: relative;
}

 .el-form-item {
  width: 100% !important;
}
</style>
